import React from 'react';
export function Problem() {
  return <section className="py-16 px-4 bg-white" data-id="element-105">
      <div className="max-w-3xl mx-auto" data-id="element-106">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-107">
          Si tenés un bebé, dejame hacerte una pregunta honesta
        </h2>

        <div className="bg-red-50 border-l-4 border-red-500 p-6 mb-8 rounded-r-lg" data-id="element-108">
          <p className="text-xl font-semibold text-red-800" data-id="element-109">
            ¿Te pasa que estás más cansada al despertar que al acostarte?
          </p>
        </div>

        <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-110">
          <p data-id="element-111">
            No porque estés criando mal. No porque tu bebé tenga "un problema".
            <br data-id="element-112" />
            <span className="font-bold text-gray-900" data-id="element-113">
              Sino porque nadie nos enseñó cómo acompañar el sueño infantil
              desde el amor.
            </span>
          </p>

          <ul className="space-y-3 pl-4" data-id="element-114">
            {['Tu bebé se despierta muchas veces.', 'Le cuesta dormirse aunque esté agotado.', 'Solo se duerme en brazos, al pecho o en movimiento.', 'Las siestas son cortas, caóticas o impredecibles.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-115">
                <span className="text-red-500 font-bold text-xl" data-id="element-116">❌</span>
                <span data-id="element-117">{item}</span>
              </li>)}
          </ul>

          <div className="my-8 p-6 bg-gray-100 rounded-xl" data-id="element-118">
            <h3 className="font-bold text-xl mb-4 text-gray-900" data-id="element-119">Y vos…</h3>
            <ul className="space-y-2" data-id="element-120">
              <li className="flex items-center gap-2" data-id="element-121">
                😩 Dormís mal desde hace semanas (o meses)
              </li>
              <li className="flex items-center gap-2" data-id="element-122">🤔 Dudás de vos misma</li>
              <li className="flex items-center gap-2" data-id="element-123">
                😫 Sentís que probaste todo
              </li>
              <li className="flex items-center gap-2" data-id="element-124">
                ❤️ Amás profundamente a tu bebé, pero estás exhausta
              </li>
            </ul>
          </div>

          <p data-id="element-125">Y cuando pedís ayuda, escuchás frases como:</p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center italic text-gray-600 font-medium" data-id="element-126">
            <div className="bg-gray-50 p-4 rounded border" data-id="element-127">
              "Dejalo llorar, se acostumbra"
            </div>
            <div className="bg-gray-50 p-4 rounded border" data-id="element-128">
              "Lo malacostumbraste"
            </div>
            <div className="bg-gray-50 p-4 rounded border" data-id="element-129">
              "Si no aprende ahora, nunca va a dormir"
            </div>
          </div>

          <p className="text-xl font-bold text-center mt-8 text-blue-900" data-id="element-130">
            Pero algo dentro tuyo te dice que ese no es el camino. <br data-id="element-131" />Y tenés
            razón.
          </p>
        </div>
      </div>
    </section>;
}